import { ISolicitudDerivarModel } from "../interfaces/solicitud/ISolicitudDerivarModel";

export class SolicitudDerivarModel implements ISolicitudDerivarModel {
    idSolicitud: number;
    idRevisor: string;
    comentarioPorDerivacion: string;
    idSede: number;

    constructor(){
        this.idSolicitud = 0;
        this.idRevisor = '';
        this.idSede = 0;
        this.comentarioPorDerivacion = '';
    }    
}